import React, { Component } from 'react';
import { Grid, Cell, Card, CardTitle, CardText, CardActions, Button } from 'react-mdl';
import FontAwesome from 'react-fa';

export default class AdultSundaySchool extends Component {
  render() {

    return (
      <div>
        <div style={{width: '90%', margin: 'auto'}}>

          <Grid>
            <Cell col={12}>
              <Card shadow={0} style={{width: '100%', margin: 'auto'}}>
                <CardTitle style={{ color: '#fff', height: '150px',  background: 'url(/images/lighthouse.jpg) center / cover'}}>成人主日學 Adult Sunday School (粵語/国语)</CardTitle>
                <CardText>
                  <p>
                    &emsp;<FontAwesome name='calendar'/> : &emsp;逢第二、三、四主日，晚上八時至九時 <br/>
                    &emsp;<FontAwesome name='map-marker'/> : &emsp;Zoom  或疫後 Portswood Church <br/>
                    &emsp;<FontAwesome name='address-card'/> : &emsp;衞傳道 Pastor Henry <br/>
                    &emsp;<FontAwesome name='envelope'/> : &emsp;henry.wai@sccc.org.uk <br/>
                  </p>
                  <h6>
                  教會將於2026年二月份開始新一季的成人主日學課程，詳細的內容如下:<br/>
                  <br/></h6>

<h5>                  
&emsp;1) 課程：廣東話：門徒訓練 <br/></h5>
<h6>
&emsp;&emsp;時間：2026年2,3,4,5,6 月第二，四週星期四、五晚上或星期六中午(未確定)，晚上八時至十時，共十課。<br/>
&emsp;&emsp;課程要求：實體課程，教會中心上課，出席率需要達80%以上，承諾要完成課程，每班六至八人，最多两班。<br/>
&emsp;&emsp;註冊要求： 需向衞傳道面試<br/>
&emsp;&emsp;課程簡介：<br/>
&emsp;&emsp;&emsp;敬拜/禱告操練, 靈修分享, 帶領查經技巧訓練和實, 帶領慕道朋友信主/成長。<br/>
  <br/></h6>
   
<h5>
&emsp;2) 課程：廣東話：摩西五經(中神課程) <br/></h5>
<h6>
&emsp;&emsp;講師：李思敬牧師<br/>
&emsp;&emsp;時間：2026年2,3,4,5,6 月，第二，三，四 主日，晚上八時至九時，共十六課。<br/>
&emsp;&emsp;地點：Zoom線上形式教學<br/>
&emsp;&emsp;課程簡介：<br/>
&emsp;&emsp;&emsp;摩西五經：《五經》乃新舊約聖經的基礎。本科將按部就班，透過文學、歷史、神學三個互動的方法，循序漸進探討經文的信息要旨。<br/>
<br/></h6>
                </CardText>
                <CardActions border>
                  <div>
      <h6>Scan QR Code to register</h6>
      <img src="https://res.sccc.org.uk/docs/adultSundaySchool-qr.jpg" alt="QR Code" style={{ width: '200px' }} />
    </div>
                  <Button colored><a href="https://forms.gle/MkuoK3ZmnjCEYETA7">Online Registration Form</a></Button>
                </CardActions>
              </Card>
            </Cell>
          </Grid>
        </div>
      </div>
    );
  }
}
